import { Fragment, memo, useEffect, useState } from 'react';
import { Select } from '@JohnLewisPartnership/jl-design-system/components/select/Select';
import { PrimaryButton } from '@JohnLewisPartnership/jl-design-system/elements/button/Button';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { SORT_OPTION_CHANGED } from '../analytics/analyticsEvents';
import { useAnalyticsData } from '../../hooks/useAnalyticsData';
import { useAnalytics } from '../../hooks/useAnalytics';
import { useExperiencesContext } from '../experiences/Experiences';
import {
  getQueryParams,
  getQueryString,
  facetsFilter,
} from '../stateful-link/StatefulLink';
import { sortOptions } from './options';
import styles from './Sort.module.scss';
import { useRouterContext } from '../../context/PlpContext';

const Sort = ({ sort = '' }) => {
  const [isInteractive, setIsInteractive] = useState(false);
  const { pageType } = useAnalyticsData();
  const { isTabletEnhancementsFlagOn, isSingleColumnLayout } =
    useExperiencesContext();

  const sortByEvent = useAnalytics(SORT_OPTION_CHANGED, {
    pagetype: pageType,
  });

  const router = useRouterContext();

  const filteredParams = Object.entries(router.query).filter(
    ([key, val]) => !['page', 'sortBy'].includes(key) && val
  );

  const actionUrl = router.asPath;

  const handleSort = (e) => {
    e.preventDefault();

    const sortBy = e.target.value;

    sortByEvent({ sort: sortBy });

    const { pathname: href, query } = router;

    const pathname = document.location.pathname;

    const url = {
      pathname: href,
      query: getQueryParams({ ...query, page: '', sortBy }, facetsFilter()),
    };

    const as = `${pathname}?${getQueryString(url.query)}`;

    router.push(url, as);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    setIsInteractive(true);
  }, []);

  return (
    <Fragment>
      <div
        className={classnames(styles.sort, {
          [styles.sort__tabletEnhancements]: isTabletEnhancementsFlagOn,
          [styles.sort__inline]: isSingleColumnLayout,
        })}
      >
        <form action={actionUrl} method="GET" className={styles.sort__form}>
          {filteredParams.map(([name, value]) => (
            <input key={name} name={name} value={value} type="hidden" />
          ))}

          <div
            className={classnames(styles.sort__select)}
            data-testid="sort-by"
          >
            <Select
              id="sortBy"
              name="sortBy"
              value={sort}
              onChange={handleSort}
              labelText="Sort by"
              showLabel={false}
            >
              {sortOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Select>
          </div>
          <PrimaryButton
            type="submit"
            className={classnames(styles.sort__submit, {
              [styles['sort__submit--visible']]: !isInteractive,
            })}
          >
            Go
          </PrimaryButton>
        </form>
      </div>
    </Fragment>
  );
};

Sort.propTypes = {
  sort: PropTypes.string,
};

export default memo(Sort);
